/**
 * @generated SignedSource<<0a4697c448951b2679526dbd48ea902f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BulkUploadNewEnrolmentsInput = {
  clientMutationId?: string | null | undefined;
  googleDriveNewBulkEnrolmentsSheetUrl: string;
};
export type BulkUploadNewEnrolmentsMutation$variables = {
  input: BulkUploadNewEnrolmentsInput;
};
export type BulkUploadNewEnrolmentsMutation$data = {
  readonly bulkUploadNewEnrolments: {
    readonly errors: any | null | undefined;
    readonly profileGroup: {
      readonly bulkUploadNewEnrolmentsProgress: number | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type BulkUploadNewEnrolmentsMutation = {
  response: BulkUploadNewEnrolmentsMutation$data;
  variables: BulkUploadNewEnrolmentsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkUploadNewEnrolmentsPayload",
    "kind": "LinkedField",
    "name": "bulkUploadNewEnrolments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileGroupNode",
        "kind": "LinkedField",
        "name": "profileGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bulkUploadNewEnrolmentsProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BulkUploadNewEnrolmentsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BulkUploadNewEnrolmentsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc685d1359c865e7170bcb591411f9b8",
    "id": null,
    "metadata": {},
    "name": "BulkUploadNewEnrolmentsMutation",
    "operationKind": "mutation",
    "text": "mutation BulkUploadNewEnrolmentsMutation(\n  $input: BulkUploadNewEnrolmentsInput!\n) {\n  bulkUploadNewEnrolments(input: $input) {\n    success\n    errors\n    profileGroup {\n      id\n      bulkUploadNewEnrolmentsProgress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "681be1ed2d99425872cbeea151b63b37";

export default node;
